import React from 'react';
import CustomHeader from './CustomHeader';
import CustomOfflineModal from './CustomOfflineModal';

class CustomContainer extends React.Component {

    //constructor
    constructor(props) {
        super(props);

        this.state = {
            surprise: false,
            surprise2: false,
            surprise2Large: false
        };

        this.surpriseTimer = null;
        this.surpriseCounter = 0;
        this.offlineModalRef = React.createRef();
    }

    componentDidUpdate(prevProps) {
        // When children change (page navigation), re-check offline status
        if (prevProps.children !== this.props.children && this.offlineModalRef.current) {
            this.offlineModalRef.current.updateElements();
        }
    }

    onSurpriseClick = () => {
        this.setState({ surprise: !this.state.surprise });
        if (null === this.surpriseTimer) {
            this.surpriseTimer = setTimeout(() => {
                this.surpriseCounter = 0;
                clearTimeout(this.surpriseTimer);
                this.surpriseTimer = null;
            }, 2000);
        } else {
            this.surpriseCounter++;
        }
        if (this.surpriseCounter > 5) {
            this.setState({
                surprise2: !this.state.surprise2,
                surprise2Large: true
            });
            setTimeout(() => {
                this.setState({ surprise2Large: false });
            }, 2000);
            this.surpriseCounter = 0;
            clearTimeout(this.surpriseTimer);
            this.surpriseTimer = null;
        }
    }

    render = () => {
        return (
            <div style={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>
                {this.state.surprise2Large &&
                    <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, zIndex: 99999, backgroundColor: 'rgba(255, 16, 240, 0.5)', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', pointerEvents: 'none' }}>
                        <p style={{ fontSize: '25vh' }}>🦄</p>
                        <p style={{ fontSize: '25px', color: '#fff', backgroundColor: 'rgba(0, 0, 0, 0.5)' }}>Secret unlocked! Happy {(new Date()).toLocaleDateString('en', { weekday: 'long' })}!</p>
                    </div>
                }
                {(this.props.noHeader) ? null :
                    <CustomHeader extraWide={this.props.extraWide} />
                }
                <CustomOfflineModal ref={this.offlineModalRef}/>
                <div style={{ flexDirection: 'column', display: 'flex', alignItems: 'center', flexGrow: 1, flexShrink: 1, overflowY: 'auto' }} id='scroll-frame'>
                    <div style={{ maxWidth: this.props.extraWide ? 1500 : 1000, width: '100%', padding: '2rem' }} id='content'>
                        {this.props.children}
                    </div>
                </div>
                <div style={{ width: '100%', flexDirection: 'column', display: 'flex', alignItems: 'center', backgroundColor: '#fff' }} className={'shadow'}>
                    <div style={{ maxWidth: this.props.extraWide ? 1500 : 1000, width: '100%' }}>
                        <div className={'standard-padding vertical-padding-2'}>
                            {this.props.footer}
                            <p
                                style={{ margin: 0, userSelect: 'none', display: 'inline-block' }}
                                onClick={() => this.onSurpriseClick()}
                            >
                                &copy; Risk Minimizer {new Date().getFullYear()} {this.state.surprise && '😎'} {this.state.surprise2 && '🦄'}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

//export
export default CustomContainer;